import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';

export default function Slider({ setActiveSlide, slides, setSwiper, swiper, domain }) {
  const goPrev = () => {
    if (swiper.activeIndex == 0) {
      swiper.slideTo(swiper.slides.length)
    } else {
      swiper.slidePrev()
    }
  }

  const goNext = () => {
    if (swiper.activeIndex == (swiper.slides.length - 1)) {
      swiper.slideTo(0)
    } else {
      swiper.slideNext()
    }
  }

  return (
    <div className='relative xl:max-w-640 w-full md:max-w-[50%]'>
      <Swiper className='relative w-full md:h-full'
        slidesPerView={1}
        onSwiper={swiper => {
          setSwiper(swiper)
        }}
        onSlideChange={slide => {
          setActiveSlide(slide.activeIndex)
        }}
      >
        {slides?.map(({ sliderimage, subdomain }, index) => {
          const href = subdomain ? `https://${subdomain}.${domain}` : '#';
          return <SwiperSlide key={index}>
            <a href={href} rel="nofollow">
              <img src={sliderimage} alt="slideImg" className='md:h-full object-cover' width="640" height="360" loading="lazy" />
            </a>
          </SwiperSlide>
        })}
      </Swiper>
      <div className='absolute z-10 w-full top-0 h-full left-0 md:flex justify-between items-center text-white px-3 text-4xl transform translate-x-0 pointer-events-none'>
        <button className='relative z-40 pointer-events-auto' onClick={goPrev} title='Previous slide'>
          <IoIosArrowBack />
        </button>
        <button className='relative z-40 pointer-events-auto' onClick={goNext} title='Next slide'>
          <IoIosArrowForward />
        </button>
      </div>
    </div>
  )
}